import { router } from 'expo-router';
import {
    BulletPoint,
    Button,
    ButtonSize,
    ButtonVariant,
    CircleNumberFiveIcon,
    CircleNumberFourIcon,
    CircleNumberOneIcon,
    CircleNumberThreeIcon,
    CircleNumberTwoIcon,
    H5Emphasized,
    ScreenContainer,
    YStack,
} from 'smoothie';

const AddToGooglePay = () => {
    return (
        <ScreenContainer hasBackButton onFallbackRoute="/home/banking">
            <YStack justifyContent="space-between">
                <YStack>
                    <H5Emphasized>
                        Add your Fruitful Card to Google Pay
                    </H5Emphasized>
                    <BulletPoint
                        icon={CircleNumberOneIcon}
                        text="Open the Google Pay app on your phone"
                    />
                    <BulletPoint
                        icon={CircleNumberTwoIcon}
                        text={`Tap "Add to Wallet" in the bottom right`}
                    />
                    <BulletPoint
                        icon={CircleNumberThreeIcon}
                        text={`Tap "Payment card"`}
                    />
                    <BulletPoint
                        icon={CircleNumberFourIcon}
                        text={`Tap "New credit or debit card"`}
                    />
                    <BulletPoint
                        icon={CircleNumberFiveIcon}
                        text="Grab your card number and CVV and enter those into the Google Pay app."
                    />
                </YStack>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Done"
                    onPress={() => {
                        if (router.canGoBack()) {
                            router.back();
                        } else {
                            router.navigate('/home/banking');
                        }
                    }}
                    buttonProps={{ marginTop: 'auto' }}
                />
            </YStack>
        </ScreenContainer>
    );
};

export default AddToGooglePay;
